"use strict";
var toPvjson_1 = require("./toPvjson");
exports.gpml2pvjson = toPvjson_1.toPvjson;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = toPvjson_1.toPvjson;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHVDQUFvQztBQUN2QixRQUFBLFdBQVcsR0FBRyxtQkFBUSxDQUFDOztBQUNwQyxrQkFBZSxtQkFBUSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/index.js
// module id = 708
// module chunks = 0